var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('img',{attrs:{"alt":"UBENSE logo","src":require("../assets/logo.png")}}),_c('br'),_c('b',[_vm._v("LICENSE PLATE READER")]),_c('div',{staticClass:"login"},[_c('UBNLPRAuthComponent')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }